import apiFaq from '@/api/faq'

const state = {
    error: null,
    isSubmitting: false,
    isLoading: false,
    faq: null
}

export const mutationTypes = {
    updateFaqStart: '[update faq] Update faq start',
    updateFaqSuccess: '[update faq] Update faq success',
    updateFaqFailure: '[update faq] Update faq failure',

    getFaqStart: '[update faq] Get faq start',
    getFaqSuccess: '[update faq] Get faq success',
    getFaqFailure: '[update faq] Get faq failure'
}

export const actionTypes = {
    updateFaq: '[update faq] Update faq',
    getFaq: '[update faq] Get faq'
}

const mutations = {
    [mutationTypes.updateFaqStart](state) {
        state.isSubmitting = true
    },

    [mutationTypes.updateFaqSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.updateFaqFailure](state, payload) {
        state.error = payload
        state.isSubmitting = false
    },

    [mutationTypes.getFaqStart](state) {
        state.isLoading = true
        state.faq = null
    },

    [mutationTypes.getFaqSuccess](state, payload) {
        state.faq = payload
        state.isLoading = false
    },

    [mutationTypes.getFaqFailure](state) {
        state.isLoading = false
    }
}

const actions = {
    [actionTypes.updateFaq](context, {id, faqInput}) {
        context.commit(mutationTypes.updateFaqStart)
        return new Promise(resolve => {
            apiFaq
                .updateFaq(id, faqInput)
                .then(response => {
                    context.commit(mutationTypes.updateFaqSuccess)
                    resolve(response.data)
                })
                .catch(resolve => {
                    context.commit(
                        mutationTypes.updateFaqFailure,
                        resolve.response.data.errors
                    )
                })
        })
    },

    [actionTypes.getFaq](context, {id}) {
        context.commit(mutationTypes.getFaqStart)
        return new Promise(resolve => {
            apiFaq
                .getFaq(id)
                .then(response => {
                    context.commit(mutationTypes.getFaqSuccess, response.data)
                    resolve(response.data)
                })
                .catch(() => {
                    context.commit(mutationTypes.getFaqFailure)
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
